(function () {
  if (window.__varionReserveListLoaded) return;
  window.__varionReserveListLoaded = true;

  const STORAGE_KEY = 'varionWildlandsReserveList';
  const FLOW_FLAG_KEY = 'varionWildlandsReserveFlow';
  const STORAGE_COOKIE_KEY = 'varionWildlandsReserveListShared';
  const FLOW_COOKIE_KEY = 'varionWildlandsReserveFlowShared';
  const RESERVE_STEP_URL = '/pages/contact?wildlands_reserve=1#ContactForm';
  const toggleId = 'varion-reserve-toggle';
  const countId = 'varion-reserve-count-bubble';
  const STRINGS = {
    reserveList: 'Reservierungsliste',
    reserveListAria: 'Reservierungsliste',
    reserveListClose: 'Reservierungsliste schlie\u00dfen',
    reserveListSubtitle: 'Deine pers\u00f6nliche Liste f\u00fcr Wildlands.',
    listEmpty: 'Noch keine Artikel in deiner Reservierungsliste.',
    requestReady: 'bereit zur Anfrage',
    continueReserve: 'Reservierungsanfrage \u00f6ffnen',
    reserveUnavailable: '',
    reserveAdded: 'Zur Reservierungsliste hinzugef\u00fcgt',
    reserveEmpty: 'Deine Reservierungsliste ist noch leer',
    reserveStockLabel: 'Wildlands-Bestand: ',
    reserveFallbackMeta: 'Reservierung in Wildlands'
  };

  function isWildlandsReserveContext() {
    const path = String((window.location && window.location.pathname) || '').toLowerCase();
    const search = String((window.location && window.location.search) || '').toLowerCase();
    if (
      path.indexOf('wildlands') !== -1 ||
      path.indexOf('zielgeraete-und-zubehoer-1') !== -1 ||
      search.indexOf('wildlands_reserve=1') !== -1
    ) {
      return true;
    }

    const productRoot = document.getElementById('va-topbox') || document.querySelector('[data-varion-default-context]');
    if (productRoot && productRoot.getAttribute('data-varion-default-context') === 'wildlands') {
      return true;
    }

    if (document.documentElement.getAttribute('data-varion-pdp-context') === 'wildlands') {
      return true;
    }

    const productInfo = document.querySelector("product-info[id^='MainProduct-']");
    if (productInfo && productInfo.getAttribute('data-varion-pdp-context') === 'wildlands') {
      return true;
    }

    const breadcrumb = document.querySelector('.varion-pdp-breadcrumb');
    if (breadcrumb && /wildlands/i.test(breadcrumb.textContent || '')) {
      return true;
    }

    return false;
  }

  let backdrop;
  let drawer;
  let listRoot;
  let toast;
  let checkoutButton;
  let summaryCount;

  function reserveIconSvg(size) {
    return (
      '<svg viewBox="0 0 24 24" width="' +
      size +
      '" height="' +
      size +
      '">' +
      '<path d="M7 4.5h10a2 2 0 0 1 2 2v12l-7-4-7 4v-12a2 2 0 0 1 2-2Z"></path>' +
      '</svg>'
    );
  }

  function normalizeStock(value) {
    const stock = Math.floor(Number(value || 0));
    return Number.isFinite(stock) && stock > 0 ? stock : 0;
  }

  function clampQuantity(quantity, stock) {
    const safeQuantity = Math.max(1, Math.floor(Number(quantity || 1)));
    if (!stock) return safeQuantity;
    return Math.min(safeQuantity, stock);
  }

  function normalizePriceCents(value) {
    const cents = Math.round(Number(value || 0));
    return Number.isFinite(cents) && cents > 0 ? cents : 0;
  }

  function formatPriceFromCents(value) {
    const cents = normalizePriceCents(value);
    if (!cents) return '';

    return (
      new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100) + ' EUR'
    );
  }

  function getDisplayPrice(item) {
    const text = String(item.price || '').trim();
    if (text) return text;
    return formatPriceFromCents(item.priceCents);
  }

  function getProductQuantity(items, productId, exceptId) {
    return items.reduce(function (sum, item) {
      if (String(item.productId || '') !== String(productId || '')) return sum;
      if (exceptId && item.id === exceptId) return sum;
      return sum + Math.max(0, Number(item.quantity || 0));
    }, 0);
  }

  function getSharedCookieSuffix() {
    const hostname = String((window.location && window.location.hostname) || '').toLowerCase();
    const isVarionHost = hostname === 'varion.company' || hostname.endsWith('.varion.company');
    const secure = window.location && window.location.protocol === 'https:' ? '; Secure' : '';
    return '; path=/; SameSite=Lax' + secure + (isVarionHost ? '; domain=.varion.company' : '');
  }

  function readCookieValue(name) {
    const encodedName = encodeURIComponent(name) + '=';
    const cookies = String(document.cookie || '').split(';');
    for (let index = 0; index < cookies.length; index += 1) {
      const entry = cookies[index].trim();
      if (entry.indexOf(encodedName) !== 0) continue;
      try {
        return decodeURIComponent(entry.slice(encodedName.length));
      } catch (error) {
        return entry.slice(encodedName.length);
      }
    }
    return '';
  }

  function writeCookieValue(name, value, maxAgeSeconds) {
    document.cookie =
      encodeURIComponent(name) +
      '=' +
      encodeURIComponent(String(value || '')) +
      '; max-age=' +
      String(maxAgeSeconds) +
      getSharedCookieSuffix();
  }

  function clearCookieValue(name) {
    document.cookie =
      encodeURIComponent(name) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + getSharedCookieSuffix();
  }

  function readFlowFlag() {
    try {
      if (window.localStorage.getItem(FLOW_FLAG_KEY) === '1') return true;
    } catch (error) {
      /* ignore */
    }

    return readCookieValue(FLOW_COOKIE_KEY) === '1';
  }

  function persistFlowFlag(enabled) {
    if (enabled) {
      try {
        window.localStorage.setItem(FLOW_FLAG_KEY, '1');
      } catch (error) {
        /* ignore */
      }
      writeCookieValue(FLOW_COOKIE_KEY, '1', 60 * 60 * 6);
      return;
    }

    try {
      window.localStorage.removeItem(FLOW_FLAG_KEY);
    } catch (error) {
      /* ignore */
    }
    clearCookieValue(FLOW_COOKIE_KEY);
  }

  function ensureDesktopHeaderToggle() {
    const host = document.querySelector('.header__icons');
    if (!host) return;

    const existing = host.querySelector('#' + toggleId);
    if (existing) {
      existing.style.display = 'inline-flex';
      existing.hidden = false;
      existing.setAttribute('aria-label', STRINGS.reserveListAria);
      existing.setAttribute('title', STRINGS.reserveList);
      return;
    }

    const cartLink = host.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'header__icon header__icon--reserve link focus-inset';
    button.id = toggleId;
    button.setAttribute('data-varion-reserve-toggle', '');
    button.setAttribute('aria-controls', 'VarionReserveDrawer');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', STRINGS.reserveListAria);
    button.setAttribute('title', STRINGS.reserveList);
    button.innerHTML =
      '<span class="svg-wrapper" aria-hidden="true">' +
      reserveIconSvg(24) +
      '</span>' +
      '<span class="visually-hidden">' +
      STRINGS.reserveList +
      '</span>' +
      '<div class="cart-count-bubble" id="' +
      countId +
      '" hidden>' +
      '<span aria-hidden="true" data-varion-reserve-count>0</span>' +
      '<span class="visually-hidden">Reservierungsliste: 0 Artikel</span>' +
      '</div>';

    host.insertBefore(button, cartLink);
  }

  function ensureDesktopRailToggle() {
    const host = document.querySelector('[data-vx-actions]');
    if (!host) return;

    const existing = host.querySelector('[data-varion-reserve-toggle]');
    if (existing) {
      existing.hidden = false;
      existing.style.display = 'inline-flex';
      existing.setAttribute('aria-label', STRINGS.reserveListAria);
      existing.setAttribute('title', STRINGS.reserveList);
      return;
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'vx-act vx-act--reserve';
    button.setAttribute('data-varion-reserve-toggle', '');
    button.setAttribute('aria-controls', 'VarionReserveDrawer');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', STRINGS.reserveListAria);
    button.setAttribute('title', STRINGS.reserveList);
    button.innerHTML =
      reserveIconSvg(22) +
      '<span class="vx-badge" data-varion-reserve-badge hidden>' +
      '<span aria-hidden="true" data-varion-reserve-count>0</span>' +
      '</span>';

    host.insertBefore(button, host.lastElementChild || null);
  }

  function ensureMobileToggle() {
    const host = document.querySelector('.varionTopActions');
    if (!host || host.querySelector('[data-varion-reserve-toggle]')) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'varionIconBtn varionReserveBtn';
    button.setAttribute('data-varion-reserve-toggle', '');
    button.setAttribute('aria-label', STRINGS.reserveListAria);
    button.innerHTML =
      '<span class="varionIcon" aria-hidden="true">' +
      reserveIconSvg(18) +
      '</span>' +
      '<span class="varionIconText">Merkliste</span>' +
      '<span class="varionCartBadge" data-varion-reserve-count aria-label="Artikel in der Reservierungsliste">0</span>';

    host.insertBefore(button, host.querySelector('.varionCartBtn') || null);
  }

  function readList() {
    let raw = '';
    try {
      raw = window.localStorage.getItem(STORAGE_KEY) || '';
    } catch (error) {
      raw = '';
    }

    if (!raw) {
      raw = readCookieValue(STORAGE_COOKIE_KEY);
      if (raw) {
        try {
          window.localStorage.setItem(STORAGE_KEY, raw);
        } catch (error) {
          /* ignore */
        }
      }
    }

    try {
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function saveList(items) {
    const serialized = JSON.stringify(items);
    try {
      window.localStorage.setItem(STORAGE_KEY, serialized);
    } catch (error) {
      /* ignore */
    }

    if (items.length) {
      writeCookieValue(STORAGE_COOKIE_KEY, serialized, 60 * 60 * 6);
    } else {
      clearCookieValue(STORAGE_COOKIE_KEY);
    }

    if (!items.length) {
      persistFlowFlag(false);
    }
    renderCount(items);
    renderDrawer(items);
    syncReserveButtons(items);
  }

  function totalCount(items) {
    return items.reduce(function (sum, item) {
      return sum + Math.max(0, Number(item.quantity || 0));
    }, 0);
  }

  function formatCountLabel(count) {
    return count === 1 ? '1 Artikel' : count + ' Artikel';
  }

  function ensureChrome() {
    if (drawer && backdrop && listRoot && toast) return;

    backdrop = document.createElement('div');
    backdrop.className = 'varion-reserve-backdrop';

    drawer = document.createElement('aside');
    drawer.className = 'varion-reserve-drawer';
    drawer.id = 'VarionReserveDrawer';
    drawer.innerHTML =
      '<div class="varion-reserve-drawer__header">' +
      '<div class="varion-reserve-drawer__copyhead">' +
      '<h2 class="varion-reserve-drawer__title">' +
      STRINGS.reserveList +
      '</h2>' +
      '<p class="varion-reserve-drawer__sub">' +
      STRINGS.reserveListSubtitle +
      '</p>' +
      '</div>' +
      '<button type="button" class="varion-reserve-drawer__close" aria-label="' +
      STRINGS.reserveListClose +
      '">&times;</button>' +
      '</div>' +
      '<div class="varion-reserve-drawer__content">' +
      '<div class="varion-reserve-list" data-varion-reserve-list></div>' +
      '</div>' +
      '<div class="varion-reserve-drawer__footer">' +
      '<div class="varion-reserve-drawer__summary">' +
      '<span data-varion-reserve-summary-count>0 Artikel</span>' +
      '<span>' +
      STRINGS.requestReady +
      '</span>' +
      '</div>' +
      '<button type="button" class="varion-reserve-drawer__checkout">' +
      STRINGS.continueReserve +
      '</button>' +
      '</div>';

    toast = document.createElement('div');
    toast.className = 'varion-reserve-toast';
    toast.setAttribute('aria-live', 'polite');

    document.body.appendChild(backdrop);
    document.body.appendChild(drawer);
    document.body.appendChild(toast);

    listRoot = drawer.querySelector('[data-varion-reserve-list]');
    checkoutButton = drawer.querySelector('.varion-reserve-drawer__checkout');
    summaryCount = drawer.querySelector('[data-varion-reserve-summary-count]');

    backdrop.addEventListener('click', closeDrawer);
    drawer
      .querySelector('.varion-reserve-drawer__close')
      .addEventListener('click', closeDrawer);
    checkoutButton.addEventListener('click', continueReserveFlow);

    drawer.addEventListener('click', function (event) {
      const removeButton = event.target.closest('[data-varion-reserve-remove]');
      if (removeButton) {
        removeItem(removeButton.getAttribute('data-varion-reserve-remove'));
        return;
      }

      const qtyButton = event.target.closest('[data-varion-reserve-qty]');
      if (qtyButton) {
        const id = qtyButton.getAttribute('data-varion-reserve-id');
        const delta = Number(qtyButton.getAttribute('data-varion-reserve-qty'));
        changeQuantity(id, delta);
      }
    });
  }

  function renderCount(items) {
    const count = totalCount(items);
    const bubble = document.getElementById(countId);

    if (bubble) {
      bubble.hidden = count === 0;
      const hidden = bubble.querySelector('.visually-hidden');
      if (hidden) hidden.textContent = 'Reservierungsliste: ' + count + ' Artikel';
    }

    document.querySelectorAll('[data-varion-reserve-count]').forEach(function (node) {
      node.textContent = count > 99 ? '99+' : String(count);
    });

    document.querySelectorAll('[data-varion-reserve-badge]').forEach(function (node) {
      node.hidden = count === 0;
    });

    document.querySelectorAll('.vx-act--reserve').forEach(function (node) {
      node.classList.toggle('has-items', count > 0);
    });
  }

  function renderDrawer(items) {
    ensureChrome();

    const count = totalCount(items);
    if (summaryCount) summaryCount.textContent = formatCountLabel(count);
    if (checkoutButton) checkoutButton.disabled = count === 0;

    if (!items.length) {
      listRoot.innerHTML =
        '<div class="varion-reserve-empty">' + STRINGS.listEmpty + '</div>';
      return;
    }

    listRoot.innerHTML = items
      .map(function (item) {
        const image = item.image
          ? '<img class="varion-reserve-item__image" src="' +
            escapeHtml(item.image) +
            '" alt="' +
            escapeHtml(item.title) +
            '">'
          : '<div class="varion-reserve-item__image"></div>';

        const variant =
          item.variantTitle && item.variantTitle !== 'Default Title'
            ? '<p class="varion-reserve-item__variant">' + escapeHtml(item.variantTitle) + '</p>'
            : '';
        const price = getDisplayPrice(item);

        const stock = normalizeStock(item.stock);
        const reservedElsewhere = getProductQuantity(items, item.productId, item.id);
        const maxForItem = stock ? Math.max(1, stock - reservedElsewhere) : Number(item.quantity || 0);
        const stockMeta = stock
          ? '<p class="varion-reserve-item__stock-badge">' + STRINGS.reserveStockLabel + stock + '</p>'
          : '<p class="varion-reserve-item__meta">' + STRINGS.reserveFallbackMeta + '</p>';
        const priceMeta = price
          ? '<p class="varion-reserve-item__price">' + escapeHtml(price) + '</p>'
          : '';

        const minusDisabled = Number(item.quantity || 0) <= 1 ? ' disabled' : '';
        const plusDisabled = stock && Number(item.quantity || 0) >= maxForItem ? ' disabled' : '';
        const url = item.url || '#';

        return (
          '<article class="varion-reserve-item">' +
          image +
          '<div>' +
          '<p class="varion-reserve-item__title"><a href="' +
          escapeHtml(url) +
          '" style="color:inherit;text-decoration:none;">' +
          escapeHtml(item.title) +
          '</a></p>' +
          variant +
          priceMeta +
          stockMeta +
          '<div class="varion-reserve-item__actions">' +
          '<div class="varion-reserve-qty">' +
          '<button type="button" data-varion-reserve-id="' +
          escapeHtml(item.id) +
          '" data-varion-reserve-qty="-1"' +
          minusDisabled +
          '>-</button>' +
          '<span>' +
          Number(item.quantity || 0) +
          '</span>' +
          '<button type="button" data-varion-reserve-id="' +
          escapeHtml(item.id) +
          '" data-varion-reserve-qty="1"' +
          plusDisabled +
          '>+</button>' +
          '</div>' +
          '<button type="button" class="varion-reserve-item__remove" data-varion-reserve-remove="' +
          escapeHtml(item.id) +
          '">Entfernen</button>' +
          '</div>' +
          '</div>' +
          '</article>'
        );
      })
      .join('');
  }

  function openDrawer() {
    ensureChrome();
    renderDrawer(readList());
    backdrop.classList.add('is-open');
    drawer.classList.add('is-open');
    document
      .querySelectorAll('[data-varion-reserve-toggle]')
      .forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
      });
  }

  function toggleDrawer() {
    if (drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
      return;
    }
    openDrawer();
  }

  function syncReserveButtons(items) {
    const productTotals = {};

    items.forEach(function (item) {
      const productId = String(item.productId || '');
      productTotals[productId] =
        Number(productTotals[productId] || 0) + Number(item.quantity || 0);
    });

    document.querySelectorAll('[data-varion-reserve-add]').forEach(function (button) {
      const productId = String(button.getAttribute('data-product-id') || '');
      const stock = normalizeStock(button.getAttribute('data-wildlands-stock'));
      const current = Number(productTotals[productId] || 0);
      const isMaxed = stock > 0 && current >= stock;

      button.disabled = isMaxed;
      button.setAttribute('aria-disabled', isMaxed ? 'true' : 'false');
      button.classList.toggle('is-maxed', isMaxed);
      button.title = isMaxed
        ? 'Maximal ' + stock + ' Artikel in Wildlands verf\u00fcgbar'
        : '';
    });
  }

  function closeDrawer() {
    if (!drawer || !backdrop) return;
    backdrop.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document
      .querySelectorAll('[data-varion-reserve-toggle]')
      .forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      });
  }

  function showToast(message) {
    ensureChrome();
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 1700);
  }

  function addItem(payload) {
    const items = readList();
    const existing = items.find(function (item) {
      return item.id === payload.id;
    });
    const stock = normalizeStock(payload.stock || (existing && existing.stock));
    const productId = String(payload.productId || (existing && existing.productId) || '');

    if (!stock) {
      showToast(STRINGS.reserveUnavailable);
      return;
    }

    const requestedItemQuantity = existing
      ? Number(existing.quantity || 0) + Number(payload.quantity || 1)
      : Number(payload.quantity || 1);
    const reservedElsewhere = getProductQuantity(items, productId, existing && existing.id);
    const maxForItem = Math.max(0, stock - reservedElsewhere);
    const clampedQuantity = Math.max(0, Math.min(requestedItemQuantity, maxForItem));

    if (clampedQuantity < 1) {
      syncReserveButtons(items);
      showToast('Maximal ' + stock + ' Artikel in Wildlands verf\u00fcgbar');
      return;
    }

    if (existing) {
      existing.quantity = clampedQuantity;
      existing.stock = stock;
      if (payload.variantTitle) existing.variantTitle = payload.variantTitle;
      if (payload.image) existing.image = payload.image;
      if (payload.price) existing.price = payload.price;
      if (payload.priceCents) existing.priceCents = payload.priceCents;
      if (payload.url) existing.url = payload.url;
    } else {
      payload.quantity = clampedQuantity;
      payload.stock = stock;
      items.push(payload);
    }

    saveList(items);

    if (requestedItemQuantity > clampedQuantity) {
      showToast('Maximal ' + stock + ' Artikel in Wildlands verf\u00fcgbar');
    } else {
      showToast(STRINGS.reserveAdded);
    }

    openDrawer();
  }

  function removeItem(id) {
    const items = readList().filter(function (item) {
      return item.id !== id;
    });
    saveList(items);
  }

  function changeQuantity(id, delta) {
    const items = readList();
    const item = items.find(function (entry) {
      return entry.id === id;
    });

    if (!item) return;

    const stock = normalizeStock(item.stock);
    const requested = Number(item.quantity || 1) + delta;
    const reservedElsewhere = getProductQuantity(items, item.productId, item.id);
    const maxForItem = stock ? Math.max(1, stock - reservedElsewhere) : requested;
    const next = Math.max(1, Math.min(requested, maxForItem));

    if (requested > next && stock) {
      showToast('Maximal ' + stock + ' Artikel in Wildlands verf\u00fcgbar');
    }

    item.quantity = next;
    saveList(items);
  }

  function continueReserveFlow() {
    const items = readList();
    if (!items.length) {
      showToast(STRINGS.reserveEmpty);
      return;
    }

    persistFlowFlag(true);

    window.location.href = RESERVE_STEP_URL;
  }

  function getRequestedQuantity(button) {
    const form = button.closest('form');
    if (!form) return 1;
    const input = form.querySelector('input[name="quantity"]');
    const quantity = input ? Number(input.value || 1) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getLiveProductPrice(button) {
    const directPrice = String(button.getAttribute('data-product-price') || '').trim();
    if (directPrice) return directPrice;

    const productInfo = button.closest('product-info') || button.closest('.product');
    if (!productInfo) return '';

    const priceNode = productInfo.querySelector(
      '.price .price-item:not(.price-item--old):not(.price__badge-sale)'
    );

    return priceNode ? String(priceNode.textContent || '').trim() : '';
  }

  function getLiveProductPriceCents(button) {
    const direct = normalizePriceCents(button.getAttribute('data-product-price-cents'));
    if (direct) return direct;

    const text = getLiveProductPrice(button);
    if (!text) return 0;

    const sanitized = text
      .replace(/\./g, '')
      .replace(',', '.')
      .replace(/[^\d.]/g, '');

    const amount = Number.parseFloat(sanitized);
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  }

  function buildPayload(button) {
    const quantity = getRequestedQuantity(button);
    const productId = String(button.getAttribute('data-product-id') || '');
    const variantId = String(button.getAttribute('data-variant-id') || '');
    const title = String(button.getAttribute('data-product-title') || 'Artikel');
    const variantTitle = String(button.getAttribute('data-variant-title') || '');
    const stock = normalizeStock(button.getAttribute('data-wildlands-stock'));

    return {
      id: productId + ':' + variantId,
      productId: productId,
      variantId: variantId,
      title: title,
      variantTitle: variantTitle,
      image: String(button.getAttribute('data-product-image') || ''),
      price: getLiveProductPrice(button),
      priceCents: getLiveProductPriceCents(button),
      url: String(button.getAttribute('data-product-url') || '#'),
      quantity: clampQuantity(quantity, stock || quantity),
      stock: stock
    };
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented) return;

      const toggle =
        event.target.closest('#' + toggleId) ||
        event.target.closest('[data-varion-reserve-toggle]');

      if (toggle) {
        event.preventDefault();
        if (drawer && drawer.classList.contains('is-open')) closeDrawer();
        else openDrawer();
        return;
      }

      const addButton = event.target.closest('[data-varion-reserve-add]');
      if (addButton) {
        event.preventDefault();
        addItem(buildPayload(addButton));
      }
    });

    window.addEventListener('storage', function () {
      const items = readList();
      renderCount(items);
      renderDrawer(items);
      syncReserveButtons(items);
    });

    document.addEventListener('varion:open-reserve-list', function () {
      openDrawer();
    });

    document.addEventListener('varion:reserve-list-force-refresh', function () {
      const items = readList();
      renderCount(items);
      renderDrawer(items);
      syncReserveButtons(items);
    });
  }

  function boot() {
    if (!isWildlandsReserveContext()) return;

    ensureChrome();
    ensureDesktopHeaderToggle();
    ensureDesktopRailToggle();
    ensureMobileToggle();
    const items = readList();
    renderCount(items);
    renderDrawer(items);
    syncReserveButtons(items);
    bindEvents();

    window.setTimeout(function () {
      ensureDesktopHeaderToggle();
      ensureDesktopRailToggle();
      ensureMobileToggle();
      renderCount(readList());
    }, 250);

    window.setTimeout(function () {
      ensureDesktopHeaderToggle();
      ensureDesktopRailToggle();
      ensureMobileToggle();
      renderCount(readList());
    }, 1000);

    window.setTimeout(function () {
      ensureDesktopHeaderToggle();
      ensureDesktopRailToggle();
      ensureMobileToggle();
      renderCount(readList());
    }, 2000);

    window.varionReserveList = {
      open: openDrawer,
      close: closeDrawer,
      toggle: toggleDrawer
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
